import React, { createRef } from 'react'
// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/js/plugins/font_family.min.js'
import 'froala-editor/js/plugins/font_size.min.js'
import 'froala-editor/js/plugins/colors.min.js'
import 'froala-editor/js/plugins/inline_class.min.js'
import 'froala-editor/js/plugins/table.min.js'
import 'froala-editor/js/plugins/align.min.js'
import 'froala-editor/js/plugins/image.min.js'
import 'froala-editor/js/plugins/lists.min.js'
import 'froala-editor/js/plugins/special_characters.min.js'

import FroalaEditorComponent, { MyComponentProps as FroalaProps } from 'react-froala-wysiwyg'
import { defaultEditorConfig } from './editor.constants'
import { Spin } from 'antd'
import customAxios from 'src/app/shared/utils/api-util/customAxios'

const ref = createRef<any>()

const Editor: React.FC<
  FroalaProps & {
    loading?: boolean
    placeholder?: string
    customConfig?: object
    customEvents?: object
  }
> = (props) => {
  const uploadFileAxios = customAxios(`multipart/form-data`)

  const {
    config = {
      ...defaultEditorConfig,
      ...props.customConfig,
      Key: process.env.REACT_APP_FROALA_KEY,
      charCounterCount: false,
      imageUpload: true,
      // imageDefaultAlign: 'left',
      // imageDefaultDisplay: 'inline-block',
      // Set max image size to 5MB.
      // imageMaxSize: 5 * 1024 * 1024,
      // Allow to upload PNG and JPG.
      // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
      events: {
        ...props.customEvents,
        'image.beforeUpload': function (files: any) {
          const editor = ref?.current?.editor
          if (files.length) {
            const data: any = new FormData()
            data.append('image', files[0])

            uploadFileAxios
              .post(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/files`, data)
              .then((res: any) => {
                if (res?.data?.fileUrl) {
                  editor.image.insert(res.data.fileUrl, null, null, editor.image.get())
                }
              })
              .catch((err) => {
                console.log(err)
                return false
              })
          }
          return false
        },

        'image.uploaded': function (response: any) {
          // Image was uploaded to the server.
          if (response) console.log('image.uploaded', response)
        },

        'image.inserted': function (img: any, response: any) {
          // Image was inserted in the editor.
          if (response) console.log('image.uploaded img: ', img)
        },

        'image.replaced': function ($img: any, response: any) {
          // Image was replaced in the editor.
        },

        'image.error': function (error: any, response: any) {
          // Bad link.
          if (error.code == 1) {
          }

          // No link in upload response.
          else if (error.code == 2) {
          }

          // Error during image upload.
          else if (error.code == 3) {
          }

          // Parsing response failed.
          else if (error.code == 4) {
          }

          // Image too text-large.
          else if (error.code == 5) {
          }

          // Invalid image type.
          else if (error.code == 6) {
          }

          // Image can be uploaded only to same domain in IE 8 and IE 9.
          else if (error.code == 7) {
          }
          // Response contains the original server response to the request if available.
        },
      },
    },
    loading,
    ...etc
  } = props

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <FroalaEditorComponent ref={ref} config={config} {...etc} />
      {loading && (
        <div
          style={{
            backgroundColor: 'rgba(251, 251, 251, 0.7)',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spin />
        </div>
      )}
    </div>
  )
}

export default Editor
